import { Link, useLocation } from "react-router-dom";

// Footer adapts to light (stone-white) pages so those routes stay fully continuous.
export const Footer = () => {
  const { pathname } = useLocation();
  const light = pathname === "/foundation";

  const wrap = light ? "bg-[var(--stone)]" : "bg-black-lux";
  const link = light
    ? "text-[var(--ink-muted)] hover:text-[var(--ink)]"
    : "text-[var(--muted)] hover:text-[var(--bone)]";
  const disclaimer = light ? "text-[var(--ink-muted)]" : "text-[var(--muted)]";

  return (
    <footer className={`border-t border-[rgba(180,139,63,0.22)] ${wrap}`} data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="jmh-footer-grid">
          <nav className="flex flex-col gap-3 text-center md:text-left" aria-label="Footer left">
            <Link to="https://stewardandstone.jennaemichelle.com" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-steward-stone">Steward &amp; Stone — Advisory</Link>
            <Link to="https://strategicassets.jennaemichelle.com" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-strategic-assets">Strategic Assets</Link>
            <Link to="https://strategicassets.jennaemichelle.com/how-we-help" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-strategic-assets-recovery">Strategic Assets — Recovery</Link>
            <Link to="/investor-login" className={`mt-2 font-display uppercase tracking-wide2 text-xs underline underline-offset-4 ${light ? "text-[var(--ink)] decoration-[var(--gold-deep)]" : "text-[var(--gold-lite)] decoration-[var(--gold)]"}`} data-testid="footer-investor-login">Investor Portal</Link>
            <Link to="/legal" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`}>Legal Document Room</Link>
          </nav>

          <div className="flex justify-center">
            <Link to="/" className="block" data-testid="footer-logo">
              <img width={2172} height={724} decoding="async" loading="lazy" src="/brand/holdings-wordmark-approved.webp" alt="Jennae Michelle Holdings" className="jmh-footer-brand" />
            </Link>
          </div>

          <nav className="flex flex-col gap-3 text-center md:text-right" aria-label="Footer right">
            <Link to="/founder" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-founder">Founder Office</Link>
            <Link to="/about" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-about">About Us</Link>
            <Link to="/contact" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-contact">Contact Us</Link>
            <a href="https://foundation.jennaemichelle.com" target="_blank" rel="noopener noreferrer" className={`font-display uppercase tracking-wide2 text-xs transition-colors ${link}`} data-testid="footer-foundation">The Jennae Michelle Foundation</a>
          </nav>
        </div>

        <nav aria-label="Legal" className="jmh-legal-links" data-tone={light ? "light" : "dark"}><Link to="/privacy">Privacy Policy</Link><Link to="/terms">Terms of Use</Link></nav>
        <div className="mt-12 hairline opacity-60" />
        <p className={`mt-6 text-center font-display uppercase tracking-wide2 text-sm leading-relaxed max-w-3xl mx-auto ${disclaimer}`}>
          Jennae Michelle Holdings LLC is not a law firm and does not provide legal representation or legal advice. Steward &amp; Stone provides strategic and operational advisory only. Strategic Assets capabilities marked "In development" are not yet operational and are not accepting clients.
        </p>
      </div>
    </footer>
  );
};

